// extracted by mini-css-extract-plugin
export default {"mobile_footer_container":"ProductContainer_mobile_footer_container__ZUm+n"};